module.exports = __webpack_public_path__ + "img/71-r.cf325492.png";